import { render } from "./TotalSalesForMonthReportGrapics.vue?vue&type=template&id=5d06664a"
import script from "./TotalSalesForMonthReportGrapics.vue?vue&type=script&lang=js"
export * from "./TotalSalesForMonthReportGrapics.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__